/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ task: NonNullable<unknown>, solution: NonNullable<unknown> }} Automation_Trigger_Task_CompletedInputs */

const en_automation_trigger_task_completed = /** @type {(inputs: Automation_Trigger_Task_CompletedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.task} completed with “${i?.solution}”`)
};

const pt_br2_automation_trigger_task_completed = /** @type {(inputs: Automation_Trigger_Task_CompletedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.task} concluída com “${i?.solution}”`)
};

/**
* | output |
* | --- |
* | "{task} completed with “{solution}”" |
*
* @param {Automation_Trigger_Task_CompletedInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const automation_trigger_task_completed = /** @type {((inputs: Automation_Trigger_Task_CompletedInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Automation_Trigger_Task_CompletedInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_automation_trigger_task_completed(inputs)
	return pt_br2_automation_trigger_task_completed(inputs)
});